import registry from '../registry';

export default registry.createApp();
